import { render } from "./DrShantanuGupta.vue?vue&type=template&id=5c1b4672"
import script from "./DrShantanuGupta.vue?vue&type=script&lang=js"
export * from "./DrShantanuGupta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__